'use strict';

angular.module('licensure.internal')
    .controller('InternalCorrespondence', ['$scope', '$q', 'MergeContactGroups', '$filter', '$timeout', '$rootScope', function ($scope, $q, MergeContactGroups, $filter, $timeout, $rootScope) {
        $scope.emailProviderEnabled = $rootScope.enterprise.settings.email_provider_enabled;
        $scope.emailProviderFromAddress = $rootScope.enterprise.settings.email_provider_from_address;

        $scope.vm = {
            toAddressForm: null,
            fromAddressForm: null
        }

        $scope.addAddress = function (correspondence, type) {
            if (type == 'to') {
                correspondence.to_address.push(angular.copy(correspondence.to_add));
                correspondence.to_add = null;
                correspondence.newToAddress = false;
            }
            else if (type == 'from') {
                correspondence.from_address.push(angular.copy(correspondence.from_add));
                correspondence.from_add = null;
                correspondence.newFromAddress = false;
            }
            else if (type == 'cc') {
                correspondence.cc_address.push(angular.copy(correspondence.cc_add));
                correspondence.cc_add = null;
                correspondence.newCCAddress = false;
            }
            else if (type == 'bcc') {
                correspondence.bcc_address.push(angular.copy(correspondence.bcc_add));
                correspondence.bcc_add = null;
                correspondence.newBCCAddress = false;
            }
            else if (type == 'replyto') {
                correspondence.replyto_address.push(angular.copy(correspondence.replyto_add));
                correspondence.replyto_add = null;
                correspondence.newReplyToAddress = false;
            }

            $scope.vm.toAddressForm.$setValidity("required", correspondence.to_address != null && correspondence.to_address.length > 0);
            if (!$scope.emailProviderEnabled) {
                $scope.vm.fromAddressForm.$setValidity("required", correspondence.from_address != null && correspondence.from_address.length > 0);
            }
        }

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);

            $scope.vm.toAddressForm.$setValidity("required", $scope.correspondence.to_address != null && $scope.correspondence.to_address.length > 0);
            if (!$scope.emailProviderEnabled) {
                $scope.vm.fromAddressForm.$setValidity("required", $scope.correspondence.from_address != null && $scope.correspondence.from_address.length > 0);
            }
        }

        $scope.optionChange = function (viewValue) {
            $scope.contactOptions = angular.copy($scope.contacts);

            if (viewValue != null && viewValue != '' && validateEmail(viewValue)) {
                $scope.contactOptions.push({ id: viewValue, name: viewValue, group: false });
            }
        }

        $scope.applyTemplate = function (correspondence) {
            if (correspondence.merge_template == null) return;

            correspondence.to_address = [];
            correspondence.from_address = [];
            correspondence.cc_address = [];
            correspondence.bcc_address = [];
            correspondence.replyto_address = [];

            correspondence.subject = correspondence.merge_template.subject;
            correspondence.message = correspondence.merge_template.message;
            correspondence.merge_entity_id = correspondence.merge_template.merge_entity_id;
            correspondence.merge_template_id = correspondence.merge_template.id;

            var promises = [];

            if (correspondence.merge_template.to_address != null) {
                var arr = correspondence.merge_template.to_address.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    correspondence.to_address.push({ id: arr[i], name: arr[i], group: false });
                }
            }

            if (correspondence.merge_template.to_contact_groups != null) {
                var arr = correspondence.merge_template.to_contact_groups.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    promises.push(MergeContactGroups.getByID(arr[i]).then(function (group) {
                        correspondence.to_address.push({ id: group.id, name: group.name, group: true });
                    }))
                }
            }

            if (correspondence.merge_template.from_address != null) {
                var arr = correspondence.merge_template.from_address.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    correspondence.from_address.push({ id: arr[i], name: arr[i], group: false });
                }
            }

            if (correspondence.merge_template.from_contact_groups != null) {
                var arr = correspondence.merge_template.from_contact_groups.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    promises.push(MergeContactGroups.getByID(arr[i]).then(function (group) {
                        correspondence.from_address.push({ id: group.id, name: group.name, group: true });
                    }))
                }
            }

            if (correspondence.merge_template.cc_address != null) {
                var arr = correspondence.merge_template.cc_address.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    correspondence.cc_address.push({ id: arr[i], name: arr[i], group: false });
                }
            }

            if (correspondence.merge_template.cc_contact_groups != null) {
                var arr = correspondence.merge_template.cc_contact_groups.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    promises.push(MergeContactGroups.getByID(arr[i]).then(function (group) {
                        correspondence.cc_address.push({ id: group.id, name: group.name, group: true });
                    }))
                }
            }

            if (correspondence.merge_template.bcc_address != null) {
                var arr = correspondence.merge_template.bcc_address.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    correspondence.bcc_address.push({ id: arr[i], name: arr[i], group: false });
                }
            }

            if (correspondence.merge_template.bcc_contact_groups != null) {
                var arr = correspondence.merge_template.bcc_contact_groups.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    promises.push(MergeContactGroups.getByID(arr[i]).then(function (group) {
                        correspondence.bcc_address.push({ id: group.id, name: group.name, group: true });
                    }))
                }
            }

            if (correspondence.merge_template.replyto_address != null) {
                var arr = correspondence.merge_template.replyto_address.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    correspondence.replyto_address.push({ id: arr[i], name: arr[i], group: false });
                }
            }

            if (correspondence.merge_template.replyto_contact_groups != null) {
                var arr = correspondence.merge_template.replyto_contact_groups.split(',');
                for (var i = 0, l = arr.length; i < l; i++) {
                    promises.push(MergeContactGroups.getByID(arr[i]).then(function (group) {
                        correspondence.replyto_address.push({ id: group.id, name: group.name, group: true });
                    }))
                }
            }

            correspondence.subject = unMerge(correspondence.subject);
            correspondence.message = unMerge(correspondence.message);
            $scope.setDocuments(correspondence);

            $q.all(promises).then(function () {
                $scope.vm.toAddressForm.$setValidity("required", correspondence.to_address != null && correspondence.to_address.length > 0);
                if (!$scope.emailProviderEnabled) {
                    $scope.vm.fromAddressForm.$setValidity("required", correspondence.from_address != null && correspondence.from_address.length > 0);
                }
            }).catch(function (response) {
                // handle error
            });
        }

        $scope.addMergeField = function (field, correspondence) {
            if (correspondence.gotosubject) {
                if (correspondence.subject == null) {
                    correspondence.subject = field.merge_name;
                }
                else {
                    correspondence.subject += field.merge_name;
                }
            }
            else {
                if (correspondence.message == null) {
                    correspondence.message = field.merge_name;
                }
                else {
                    correspondence.message += field.merge_name;
                }
            }
        }

        var unMerge = function (string) {
            if (string != null) {
                if ($scope.merge_objects != null) {
                    $scope.merge_objects.forEach(function (object) {
                        if (object.merge_name != null && object.value != null && string.indexOf(object.merge_name) >= 0) {
                            var value = object.value;
                            if (value.substr(0, 3) == '<p>') {
                                value = value.substr(3);
                            }
                            if (value.substr(-4, 4) == '</p>') {
                                value = value.substr(0,value.length-4);
                            }
                            if (angular.isString(value)) {
                                var re = new RegExp(object.merge_name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
                                string = string.replace(re, value);
                            }
                        }
                    })
                }
                if ($scope.merge_fields != null) {
                    $scope.merge_fields.forEach(function (field) {
                        if ($scope.correspondenceObject != null && $scope.correspondenceObject[field.json] !== undefined && field.merge_name != null && !field.multiple && string.indexOf(field.merge_name) >= 0) {
                            var value = $scope.correspondenceObject[field.json] == null ? '' : $scope.correspondenceObject[field.json];
                            if (isValidDate(value)) {
                                if (field.table_name === 'Complaints') {
                                    value = $filter('date')(value, 'MM/dd/yyyy', 'UTC');
                                }
                                else {
                                    value = $filter('date')(value, 'MM/dd/yyyy');
                                }
                            }
                            if (angular.isString(value)) {
                                var re = new RegExp(field.merge_name.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g');
                                string = string.replace(re, value);
                            }
                        }
                    })
                }
            }
            else {
                string = '';
            }

            return string;
        }

        if ($scope.correspondenceID == null) {
            var timer = $timeout(function () {
                $scope.vm.toAddressForm.$setValidity("required", false);
                if (!$scope.emailProviderEnabled) {
                    $scope.vm.fromAddressForm.$setValidity("required", false);
                }
            }, 0);

            $scope.$on('$destroy', function () {
                $timeout.cancel(timer);
            });
        }
        // Ckeditor Setup
        $scope.cke_skin = 'bootstrapck';
    }])
    .directive('internalCorrespondence', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'components/correspondence/correspondence.html',
            controller: 'InternalCorrespondence'
        };
    }])
;